module.exports = __webpack_public_path__ + "img/us-3.e0a2817b.webp";